'use client';
import { useState } from 'react';

import { useQuery } from '@tanstack/react-query';
import { IErrorResponse } from '@shared/api';

import { AGREEMENTS_CACHE_KEY, getInsuranceAgreements, TAgreementsResponse } from '../api';

export const useGetAgreements = (enabled = true) => {
  const [isEnrollModalOpen, setEnrollModalOpen] = useState(false);
  const { data, isLoading, isError, refetch } = useQuery<TAgreementsResponse, IErrorResponse>({
    queryKey: [AGREEMENTS_CACHE_KEY],
    queryFn: () => getInsuranceAgreements(),
    enabled,
    retry: false,
  });

  return {
    agreements: {
      data: data as TAgreementsResponse | undefined,
      isLoading,
      isError,
      refetch,
    },
    modal: {
      isOpen: isEnrollModalOpen,
      close: () => setEnrollModalOpen(false),
    },
  };
};
